import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../../graphql/types.generated';
export type UpdateHsCodesMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpdateHsCodesInput;
}>;

export type UpdateHsCodesMutationResult = { __typename?: 'Mutation' } & {
  updateHSCodes: { __typename?: 'UpdateHSCodesPayload' } & {
    errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
  };
};

export const UpdateHsCodesDocument = gql`
  mutation updateHsCodes($input: UpdateHSCodesInput!) {
    updateHSCodes(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
